module.exports = global.WebSocket || global.MozWebSocket;
